/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PaymentDetailsSourceOfMoneyViewModel } from './PaymentDetailsSourceOfMoneyViewModel';
import {
    PaymentDetailsSourceOfMoneyViewModelFromJSON,
    PaymentDetailsSourceOfMoneyViewModelFromJSONTyped,
    PaymentDetailsSourceOfMoneyViewModelToJSON,
} from './PaymentDetailsSourceOfMoneyViewModel';
import type { PaymentDetailsUnitTransferInvestmentViewModel } from './PaymentDetailsUnitTransferInvestmentViewModel';
import {
    PaymentDetailsUnitTransferInvestmentViewModelFromJSON,
    PaymentDetailsUnitTransferInvestmentViewModelFromJSONTyped,
    PaymentDetailsUnitTransferInvestmentViewModelToJSON,
} from './PaymentDetailsUnitTransferInvestmentViewModel';

/**
 * 
 * @export
 * @interface PaymentDetailsUnitTransferViewModel
 */
export interface PaymentDetailsUnitTransferViewModel {
    /**
     * 
     * @type {number}
     * @memberof PaymentDetailsUnitTransferViewModel
     */
    paymentCategoryId: number;
    /**
     * 
     * @type {number}
     * @memberof PaymentDetailsUnitTransferViewModel
     */
    paymentMethodId?: number;
    /**
     * 
     * @type {number}
     * @memberof PaymentDetailsUnitTransferViewModel
     */
    totalAmount: number;
    /**
     * 
     * @type {number}
     * @memberof PaymentDetailsUnitTransferViewModel
     */
    partyId?: number;
    /**
     * 
     * @type {boolean}
     * @memberof PaymentDetailsUnitTransferViewModel
     */
    isInvestor?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PaymentDetailsUnitTransferViewModel
     */
    isCancelDebitOrderAllowed: boolean;
    /**
     * 
     * @type {Array<PaymentDetailsSourceOfMoneyViewModel>}
     * @memberof PaymentDetailsUnitTransferViewModel
     */
    sourcesOfMoney: Array<PaymentDetailsSourceOfMoneyViewModel>;
    /**
     * 
     * @type {Array<PaymentDetailsUnitTransferInvestmentViewModel>}
     * @memberof PaymentDetailsUnitTransferViewModel
     */
    investments: Array<PaymentDetailsUnitTransferInvestmentViewModel>;
}

/**
 * Check if a given object implements the PaymentDetailsUnitTransferViewModel interface.
 */
export function instanceOfPaymentDetailsUnitTransferViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "paymentCategoryId" in value;
    isInstance = isInstance && "totalAmount" in value;
    isInstance = isInstance && "isCancelDebitOrderAllowed" in value;
    isInstance = isInstance && "sourcesOfMoney" in value;
    isInstance = isInstance && "investments" in value;

    return isInstance;
}

export function PaymentDetailsUnitTransferViewModelFromJSON(json: any): PaymentDetailsUnitTransferViewModel {
    return PaymentDetailsUnitTransferViewModelFromJSONTyped(json, false);
}

export function PaymentDetailsUnitTransferViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaymentDetailsUnitTransferViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'paymentCategoryId': json['PaymentCategoryId'],
        'paymentMethodId': !exists(json, 'PaymentMethodId') ? undefined : json['PaymentMethodId'],
        'totalAmount': json['TotalAmount'],
        'partyId': !exists(json, 'PartyId') ? undefined : json['PartyId'],
        'isInvestor': !exists(json, 'IsInvestor') ? undefined : json['IsInvestor'],
        'isCancelDebitOrderAllowed': json['IsCancelDebitOrderAllowed'],
        'sourcesOfMoney': ((json['SourcesOfMoney'] as Array<any>).map(PaymentDetailsSourceOfMoneyViewModelFromJSON)),
        'investments': ((json['Investments'] as Array<any>).map(PaymentDetailsUnitTransferInvestmentViewModelFromJSON)),
    };
}

export function PaymentDetailsUnitTransferViewModelToJSON(value?: PaymentDetailsUnitTransferViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'PaymentCategoryId': value.paymentCategoryId,
        'PaymentMethodId': value.paymentMethodId,
        'TotalAmount': value.totalAmount,
        'PartyId': value.partyId,
        'IsInvestor': value.isInvestor,
        'IsCancelDebitOrderAllowed': value.isCancelDebitOrderAllowed,
        'SourcesOfMoney': ((value.sourcesOfMoney as Array<any>).map(PaymentDetailsSourceOfMoneyViewModelToJSON)),
        'Investments': ((value.investments as Array<any>).map(PaymentDetailsUnitTransferInvestmentViewModelToJSON)),
    };
}

